/* 2026 WilderdijkDynamics. Shared email preference; this never grants access to private lists. */
(function () {
  'use strict';
  if (window.WDContactEmail) return;
  var key = 'wd-contact-email';
  var lifetime = 30 * 24 * 60 * 60 * 1000;
  var cached = null;
  function valid(email) {
    return typeof email === 'string' && email.length <= 254 && /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(email);
  }
  function forget() {
    cached = null;
    try { localStorage.removeItem(key); } catch (e) {}
    try { sessionStorage.removeItem(key); } catch (e) {}
  }
  function read() {
    var raw = '';
    try { raw = localStorage.getItem(key) || ''; } catch (e) {}
    if (!raw) { try { raw = sessionStorage.getItem(key) || ''; } catch (e) {} }
    if (raw) {
      try { cached = JSON.parse(raw); } catch (e) { forget(); }
    }
    if (!cached) return '';
    if (!valid(cached.email) || !Number.isFinite(cached.expires) || cached.expires <= Date.now()) {
      forget();
      return '';
    }
    return cached.email;
  }
  function fill(input) {
    if (input && !input.value.trim()) input.value = read();
  }
  function fillAll() {
    document.querySelectorAll('[data-wd-restock-form] input[name="email"], [data-wd-email-form] input[type="email"]').forEach(fill);
  }
  function remember(email) {
    email = String(email || '').trim();
    if (!valid(email)) return;
    cached = { email: email, expires: Date.now() + lifetime };
    var raw = JSON.stringify(cached);
    try { localStorage.setItem(key, raw); } catch (e) {}
    try { sessionStorage.setItem(key, raw); } catch (e) {}
    fillAll();
  }
  function validatePhone(input) {
    if (!input) return true;
    var phone=input.value.trim(), digits=(phone.match(/\d/g)||[]).length;
    var ok=!phone || (phone.length<=60 && /^[+0-9(). /-]+$/.test(phone) && digits>=6 && digits<=20);
    var lang=document.documentElement.lang.slice(0,2);
    input.setCustomValidity(ok?'':lang==='de'?'Gib eine gültige Telefonnummer ein.':lang==='en'?'Enter a valid phone number.':'Vul een geldig telefoonnummer in.');
    return ok;
  }
  document.addEventListener('input',function(event){
    if(event.target.matches('[data-wd-restock-form] input[name="phone"], [data-wd-email-form] input[name="phone"]'))event.target.setCustomValidity('');
  });
  window.WDContactEmail = { read: read, fill: fill, remember: remember, forget: forget, validatePhone: validatePhone };
  fillAll();
  document.addEventListener('focusin', function (event) {
    if (event.target.matches('[data-wd-restock-form] input[name="email"], [data-wd-email-form] input[type="email"]')) fill(event.target);
  });
  document.addEventListener('shopify:section:load', fillAll);
  window.addEventListener('storage', function (event) {
    if (event.key === key) { cached = null; fillAll(); }
  });
})();
